import { User } from '@auth0/auth0-react';
import { Navigate } from 'react-router-dom';
import { canAccessAuditTrail } from 'utils/auth';
import { useUserStateStore } from 'zstore/userStateStore';
import General from './General';

const AuditTrail = () => {
  const { user } = useUserStateStore();

  if (!canAccessAuditTrail(user as User)) {
    return <Navigate to="/myaccount/settings" replace />;
  }

  return <General />;
};

export default AuditTrail;
